__turbopack_context__.v({
  "articleContent": "ArticleDetail-module-scss-module__aPgmSG__articleContent",
  "avatarEmoji": "ArticleDetail-module-scss-module__aPgmSG__avatarEmoji",
  "imgWrapper": "ArticleDetail-module-scss-module__aPgmSG__imgWrapper",
  "showReplyBar": "ArticleDetail-module-scss-module__aPgmSG__showReplyBar",
});
